import React from 'react';
import MaterialIcon from '@/components/ui/MaterialIcon';
import Modal from '@/components/ui/Modal';

interface IOSInstallInstructionsProps {
  isOpen: boolean;
  onClose: () => void;
}

const Step: React.FC<{ index: number; title: string; description: string; icon?: React.ReactNode }> = ({
  index,
  title,
  description,
  icon,
}) => (
  <li className="flex gap-3 items-start">
    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary text-[#102216] font-bold text-sm">
      {index}
    </div>
    <div className="flex-1">
      <div className="flex items-center gap-2 mb-0.5">
        <p className="font-semibold text-gray-900 dark:text-white">{title}</p>
        {icon}
      </div>
      <p className="text-sm text-gray-600 dark:text-gray-300">{description}</p>
    </div>
  </li>
);

const IOSInstallInstructions: React.FC<IOSInstallInstructionsProps> = ({ isOpen, onClose }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Installer l'application Leeris"
  >
    <div className="flex flex-col gap-5">
      <p className="text-sm text-gray-600 dark:text-gray-300">
        Pour installer Leeris sur votre iPhone et y accéder hors connexion, suivez ces 3 étapes dans Safari :
      </p>
      <ol className="flex flex-col gap-5">
        <Step
          index={1}
          title="Ouvrez le menu de partage"
          description="Touchez l'icône de partage dans la barre du navigateur Safari."
          icon={<MaterialIcon icon="ios_share" className="text-blue-500" style={{ fontSize: 20 }} />}
        />
        <Step
          index={2}
          title={`Sélectionnez "Sur l'écran d'accueil"`}
          description={`Faites défiler le menu et touchez "Sur l'écran d'accueil".`}
          icon={<MaterialIcon icon="add_box" className="text-gray-500" style={{ fontSize: 20 }} />}
        />
        <Step
          index={3}
          title={`Touchez "Ajouter"`}
          description="L'icône Leeris apparaît sur votre écran d'accueil, comme une vraie application."
        />
      </ol>
      <div className="rounded-xl bg-primary/10 border border-primary/20 p-3 text-xs text-gray-700 dark:text-gray-200">
        <div className="flex items-start gap-2">
          <MaterialIcon icon="info" className="text-primary shrink-0" style={{ fontSize: 16 }} />
          <p>
            L'installation ne fonctionne que dans <strong>Safari</strong>. Si vous utilisez Chrome ou un autre navigateur sur iPhone, ouvrez d'abord la page dans Safari.
          </p>
        </div>
      </div>
    </div>
  </Modal>
);

export default IOSInstallInstructions;
